<div class="container">
    <!-- Header usando componente shared -->
    <app-page-header
        title="Consultas Ley de Joder"
        subtitle="Consulta el estado de bloqueo CRC por teléfono o correo"
        icon="shield">
    </app-page-header>

    <!-- Card principal -->
    <div class="main-card">
        <nav class="tabs-container">
            <div class="tabs-content">
                <a class="tab-item"
                    [ngClass]="{ 'tab-item-active': activeTab === 'phone', 'tab-item-inactive': activeTab !== 'phone' }"
                    (click)="setActiveTab('phone')" 
                    tabindex="0"
                    role="tab"
                    [attr.aria-selected]="activeTab === 'phone'">
                    <div class="tab-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                        </svg>
                    </div>
                    <div class="tab-content">
                        <span class="tab-title">Consulta por Teléfono</span>
                        <span class="tab-description">Verifica estado CRC con número</span>
                    </div>
                </a>
                
                <a class="tab-item"
                    [ngClass]="{ 'tab-item-active': activeTab === 'email', 'tab-item-inactive': activeTab !== 'email' }"
                    (click)="setActiveTab('email')" 
                    tabindex="0"
                    role="tab"
                    [attr.aria-selected]="activeTab === 'email'">
                    <div class="tab-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                            <polyline points="22,6 12,13 2,6"/>
                        </svg>
                    </div>
                    <div class="tab-content">
                        <span class="tab-title">Consulta por Correo</span>
                        <span class="tab-description">Verifica estado CRC con email</span>
                    </div>
                </a>
            </div>
        </nav>
        
        <div class="content" role="tabpanel">
            <div *ngIf="activeTab === 'phone'; else templateEmail" class="fade-in">
                <app-crc-consults-phone></app-crc-consults-phone>
            </div>
            <ng-template #templateEmail>
                <div class="fade-in">
                    <app-crc-consult-email></app-crc-consult-email>
                </div>
            </ng-template>
        </div>
    </div>
</div>